import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class TutorialPage extends Model<Schemas['tutorialPages'], Models> {}
